__webpack_require__.p = "https://trading.iux.com/";